<template>
  <div class="sidebar-wrapper">
    <div class="floating-sidebar">
      <div style="padding:7px 10px;">
      <!-- 在线咨询 -->
      <div class="sidebar-item" @click="openCustomerService">
        <div class="icon-wrapper">
          <!-- 在线咨询图标 -->
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.27865 26.8255C9.12566 26.8255 8.97476 26.79 8.83785 26.7217C8.67387 26.6397 8.53595 26.5137 8.43955 26.3578C8.34315 26.2019 8.29208 26.0222 8.29206 25.8389V22.1238C3.94545 20.2656 1.17456 16.4443 1.17456 12.2244C1.17456 6.1315 6.9278 1.17456 14 1.17456C21.0722 1.17456 26.8255 6.1315 26.8255 12.2244C26.8255 18.2209 21.2528 23.1169 14.3348 23.2703L9.87162 26.6272C9.70074 26.7559 9.49259 26.8255 9.27865 26.8255ZM14 3.14772C8.01603 3.14772 3.14772 7.2195 3.14772 12.2244C3.14772 15.8147 5.68884 19.0748 9.62117 20.53C10.008 20.6731 10.2652 21.0424 10.2652 21.4552V23.8621L13.4071 21.499C13.578 21.3704 13.7861 21.3008 14 21.3008C19.984 21.3008 24.8523 17.229 24.8523 12.2244C24.8523 7.2195 19.984 3.14772 14 3.14772H14Z" fill="#333333"/>
            <path d="M13.3795 18.6847C9.79938 18.6847 6.87965 16.5386 5.56885 12.9443L7.88593 12.0993C8.84023 14.717 10.8428 16.2183 13.3795 16.2183V18.6847Z" :fill="themeColor"/>
          </svg>
        </div>
        <span class="item-text">在线咨询</span>
      </div>

      <!-- 微信咨询 -->
      <div class="sidebar-item" @click="handleWechatConsult">
        <div class="icon-wrapper">
          <!-- 微信咨询图标 -->
          <svg width="28" height="25" viewBox="0 0 28 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_sidebar)">
              <path d="M22.3937 8.62604C25.6588 9.74896 28 12.7706 28 16.3333C28 17.691 27.6535 19.0079 27.0026 20.1921C26.9396 20.2942 26.8346 20.4779 26.6877 20.7331L27.1706 22.4379C27.3806 23.2035 26.6667 23.8977 25.8793 23.6935L24.1155 23.224L23.916 23.3363C22.6142 24.0917 21.1234 24.5 19.6011 24.4898C17.0394 24.4898 14.7507 23.3771 13.2073 21.6213C12.5879 21.7131 11.9685 21.7642 11.3491 21.7642C9.27034 21.7642 7.27559 21.2231 5.52231 20.2227C5.45932 20.1921 5.31234 20.1002 5.07087 19.9675L2.4252 20.6617C1.6378 20.8658 0.923885 20.1615 1.14436 19.406L1.85827 16.8948C1.67979 16.609 1.50131 16.3129 1.33333 16.0271C0.461942 14.455 0 12.689 0 10.8923C0 4.86938 5.08137 0 11.3491 0C16.5984 0 21.1234 3.45042 22.3622 8.26875C22.3937 8.39125 22.4042 8.51375 22.3832 8.62604H22.3937ZM20.1575 8.17688C18.9501 4.56313 15.4121 2.03146 11.3491 2.03146C6.23622 2.04167 2.09974 6.0025 2.09974 10.8923C2.09974 12.3725 2.47769 13.7915 3.1916 15.0573C3.28609 15.2308 3.52756 15.6188 3.90551 16.2313C4.05249 16.466 4.09449 16.7621 4.021 17.0275L3.67454 18.2423L4.96588 17.9054C5.23885 17.834 5.52231 17.8748 5.76378 18.0075C6.23622 18.2729 6.50919 18.426 6.61417 18.4873C8.05249 19.3142 9.70079 19.7429 11.3701 19.7429C11.5696 19.7429 11.769 19.7429 11.9685 19.7225C11.4751 18.6608 11.2126 17.5073 11.2126 16.3333C11.2126 11.8212 14.9711 8.16667 19.6115 8.16667C19.8005 8.16667 19.9895 8.16667 20.168 8.18708L20.1575 8.17688ZM24.5459 20.8454C24.4724 20.58 24.5144 20.2942 24.6509 20.0594C24.8189 19.7838 24.9869 19.4979 25.1549 19.2223C25.6483 18.3342 25.9003 17.344 25.9003 16.3333C25.9003 12.9544 23.0761 10.2083 19.6011 10.2083C16.126 10.2083 13.3018 12.9544 13.3018 16.3333C13.3018 19.7123 16.126 22.4583 19.6011 22.4583C20.7349 22.4583 21.8583 22.1623 22.8346 21.5906C22.9081 21.5498 23.1076 21.4375 23.4436 21.2435C23.685 21.1108 23.979 21.07 24.252 21.1415L24.6614 21.2537L24.5459 20.8556V20.8454ZM8.05249 9.1875C7.27559 9.1875 6.65617 8.575 6.65617 7.82979C6.65617 7.08458 7.28609 6.47208 8.05249 6.47208C8.8189 6.47208 9.44882 7.08458 9.44882 7.82979C9.44882 8.575 8.8189 9.1875 8.05249 9.1875ZM14.3517 9.1875C13.5748 9.1875 12.9554 8.575 12.9554 7.82979C12.9554 7.08458 13.5853 6.47208 14.3517 6.47208C15.1181 6.47208 15.748 7.08458 15.748 7.82979C15.748 8.575 15.1181 9.1875 14.3517 9.1875Z" fill="#333333"/>
              <path d="M17.1968 16.2823C17.7767 16.2823 18.2467 15.8252 18.2467 15.2614C18.2467 14.6976 17.7767 14.2406 17.1968 14.2406C16.617 14.2406 16.147 14.6976 16.147 15.2614C16.147 15.8252 16.617 16.2823 17.1968 16.2823Z" :fill="themeColor"/>
              <path d="M22.0892 16.2823C22.6691 16.2823 23.1391 15.8252 23.1391 15.2614C23.1391 14.6976 22.6691 14.2406 22.0892 14.2406C21.5094 14.2406 21.0394 14.6976 21.0394 15.2614C21.0394 15.8252 21.5094 16.2823 22.0892 16.2823Z" :fill="themeColor"/>
            </g>
            <defs>
              <clipPath id="clip0_sidebar">
                <rect width="28" height="24.5" fill="white"/>
              </clipPath>
            </defs>
          </svg>
        </div>
        <span class="item-text">微信咨询</span>
      </div>

      <!-- 关注我们 -->
      <div class="sidebar-item" @click="handleFollowUs">
        <div class="icon-wrapper">
          <!-- 关注我们图标 -->
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.792 2.47998C22.396 2.47998 25.506 5.06998 26.42 8.69698C26.597 9.39898 26.687 10.125 26.687 10.863C26.687 12.515 26.252 13.953 25.455 15.401C25.3245 15.6382 25.1051 15.8139 24.8451 15.8894C24.5851 15.9649 24.3057 15.934 24.0685 15.8035C23.8313 15.673 23.6556 15.4536 23.5801 15.1936C23.5046 14.9336 23.5355 14.6542 23.666 14.417C24.309 13.249 24.646 12.137 24.646 10.863C24.646 10.293 24.576 9.73498 24.44 9.19598C23.749 6.45198 21.432 4.52198 18.792 4.52198C17.277 4.52198 15.835 5.15098 14.736 6.29398C14.6408 6.39288 14.5267 6.47156 14.4004 6.52531C14.2741 6.57905 14.1382 6.60675 14.001 6.60675C13.8637 6.60675 13.7279 6.57905 13.6016 6.52531C13.4753 6.47156 13.3612 6.39288 13.266 6.29398C12.176 5.16598 10.701 4.52198 9.20799 4.52198C5.99799 4.52198 3.35399 7.35198 3.35399 10.863C3.35399 12.586 3.83999 13.726 5.08999 15.653C6.08299 17.194 7.81299 19.029 9.97999 20.964C10.5915 21.5088 11.2136 22.0416 11.846 22.562L12.43 23.038L12.89 23.403L13.331 23.746L13.399 23.797C13.5719 23.9335 13.7861 24.007 14.0064 24.0056C14.2267 24.0041 14.4399 23.9277 14.611 23.789L15.041 23.454L15.5 23.089L16.035 22.653C16.244 22.4809 16.5128 22.3988 16.7823 22.4249C17.0518 22.4509 17.2999 22.583 17.472 22.792C17.6441 23.001 17.7262 23.2698 17.7001 23.5393C17.674 23.8088 17.542 24.0569 17.333 24.229L16.778 24.681L16.102 25.218L15.854 25.409C15.3244 25.8221 14.6717 26.046 14 26.045C13.3863 26.0461 12.787 25.8591 12.283 25.509L12.09 25.366L11.631 25.011L11.021 24.523C10.2045 23.864 9.40425 23.1851 8.62099 22.487C6.32699 20.44 4.48999 18.49 3.37599 16.762C1.92899 14.532 1.31299 13.084 1.31299 10.863C1.31299 6.25498 4.83699 2.47998 9.20799 2.47998C10.908 2.47998 12.574 3.07998 13.929 4.14898L13.998 4.20398L14.072 4.14398C15.3541 3.11713 16.9351 2.53456 18.577 2.48398L18.792 2.47998Z" fill="#333333"/>
            <path d="M23.916 18.813C24.1803 18.8114 24.4349 18.9125 24.6261 19.0949C24.8174 19.2774 24.9303 19.5269 24.9412 19.791C24.9521 20.055 24.8601 20.313 24.6845 20.5106C24.5089 20.7081 24.2636 20.8298 24 20.85L23.916 20.853H18.083C17.8155 20.8597 17.556 20.7609 17.3606 20.578C17.1652 20.3951 17.0495 20.1428 17.0385 19.8753C17.0274 19.6079 17.122 19.3469 17.3017 19.1485C17.4814 18.9502 17.7318 18.8304 17.999 18.815L18.083 18.812H23.916V18.813Z" :fill="themeColor"/>
            <path d="M21.001 15.895C21.533 15.895 21.975 16.302 22.019 16.831L22.022 16.915V22.749C22.0287 23.0166 21.9299 23.2761 21.747 23.4715C21.5641 23.6669 21.3117 23.7826 21.0443 23.7936C20.7769 23.8046 20.5158 23.7101 20.3175 23.5304C20.1191 23.3507 19.9993 23.1002 19.984 22.833L19.98 22.749V16.915C19.98 16.352 20.438 15.895 21.001 15.895Z" :fill="themeColor"/>
          </svg>
        </div>
        <span class="item-text">关注我们</span>
      </div>
      </div>
    </div>
    
    <!-- 独立活动组件 -->
    <ActivityWidget />
  </div>

  <!-- 二维码弹窗 -->
  <teleport to="body">
    <transition name="fade">
      <div v-if="showQrcodeModal" class="qrcode-modal-backdrop" @click="closeQrcodeModal">
        <div class="qrcode-card" @click.stop>
          <img 
            v-if="qrcodeItem" 
            :src="$fixAssetUrl(qrcodeItem.qrcodeImage)" 
            :alt="qrcodeItem.title" 
            class="qrcode-image" 
          />
          <p v-if="qrcodeItem" class="qrcode-label">{{ qrcodeItem.title }}</p>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
// 客服行为统一在 CustomerService 中维护，页面只绑定咨询事件。
import { openCustomerService } from '@/utils/CustomerService'
import { ref, computed, onMounted } from 'vue'
import ActivityWidget from '../ActivityWidget/index.vue'

/**
 * 企业微信咨询链接配置
 */
const wechatConsultLinks = {
  de: 'https://work.weixin.qq.com/ca/cawcde25146beb5ac5',
  fr: 'https://work.weixin.qq.com/ca/cawcdec192a9ccb871',
  ru: 'https://work.weixin.qq.com/ca/cawcdee3d64751ed06',
  es: 'https://work.weixin.qq.com/ca/cawcde6cfbcb82b3a3',
  pt: 'https://work.weixin.qq.com/ca/cawcde7f89fb83f38a'
}

/**
 * 主题色配置
 */
const themeColors = {
  es: '#FF5B16',
  fr: '#FF1F59',
  de: '#F93636',
  ru: '#0278DE',
  pt: '#00AA81'
}

/**
 * 当前站点
 */
const currentProfile = ref('de')

/**
 * 主题色
 */
const themeColor = computed(() => {
  return themeColors[currentProfile.value] || '#F93636'
})

/**
 * Footer 配置（用于获取二维码）
 */
const footerConfig = ref({
  socialMedia: []
})

/**
 * 二维码弹窗显示状态
 */
const showQrcodeModal = ref(false)

/**
 * 计算属性：获取需要显示的二维码（只显示公众号）
 */
const qrcodeItem = computed(() => {
  return footerConfig.value.socialMedia.find(item => {
    return item.type === 'qrcode' && item.key === 'wechat'
  })
})


/**
 * 处理微信咨询点击，跳转企业微信
 */
const handleWechatConsult = () => {
  const link = wechatConsultLinks[currentProfile.value]
  if (link && typeof window !== 'undefined') {
    window.open(link, '_blank')
  }
}

/**
 * 处理关注我们点击，显示二维码弹窗
 */
const handleFollowUs = () => {
  if (qrcodeItem.value) {
    showQrcodeModal.value = true
  }
}

/**
 * 关闭二维码弹窗
 */
const closeQrcodeModal = () => {
  showQrcodeModal.value = false
}

/**
 * 加载 Footer 配置获取二维码
 */
const loadFooterConfig = async () => {
  if (typeof window === 'undefined') {
    return
  }
  
  currentProfile.value = __SITE_PROFILE__ || 'de'
  
  try {
    const modules = import.meta.glob('@/stores/*/footer.js')
    const path = `/src/stores/${currentProfile.value}/footer.js`
    
    if (modules[path]) {
      const mod = await modules[path]()
      if (mod.default && mod.default.socialMedia) {
        footerConfig.value = mod.default
      }
    }
  } catch (e) {
    console.error('Failed to load footer config:', e)
  }
}

onMounted(() => {
  loadFooterConfig()
})
</script>

<style scoped lang="scss">
.sidebar-wrapper {
  position: fixed;
  right: 0;
  top: 65%;
  transform: translateY(-50%);
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.floating-sidebar {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.sidebar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 7px 0px;
  cursor: pointer;
  transition: background-color 0.2s;
  position: relative;
  
  
  &:active {
    background-color: #f9f9f9;
  }
  
  .icon-wrapper {
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 6px;
    
    svg {
      width: 28px;
      height: 28px;
    }
  }
  
  .item-text {
    font-size: 11px;
    color: #333;
    white-space: nowrap;
    font-weight: 400;
  }
}

// 二维码弹窗样式
.qrcode-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

// 单个二维码卡片样式
.qrcode-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  
  .qrcode-image {
    width: 200px;
    height: 200px;
    object-fit: contain;
    border-radius: 8px;
  }
  
  .qrcode-label {
    margin: 16px 0 0 0;
    font-size: 15px;
    color: #333;
    text-align: center;
    font-weight: 500;
  }
}

// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
